// Logger utility to handle console logs based on environment
const isDevelopment = process.env.NODE_ENV === "development";

const logger = {
  log: (...args: unknown[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  info: (...args: unknown[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  warn: (...args: unknown[]) => {
    // Warnings are important enough to keep in production
    console.warn(...args);
  },

  error: (...args: unknown[]) => {
    // Errors should always be logged
    console.error(...args);
  },

  debug: (...args: unknown[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  // Special method for development-only code blocks
  dev: (callback: () => void) => {
    if (isDevelopment) {
      callback();
    }
  },
};

export default logger;
